<template>
  <div class="plan">
    <copy-workout-dialog ref="copyWorkout" />
    <v-container fluid>
      <v-card>
      <v-layout>
        <v-flex>
            <v-layout row wrap>
              <v-flex md4>
                <span class="d-inline-block" v-if="$mq !== 'sm'">
                  <v-btn flat class="upper" small icon v-tooltip="'poprzedni'" @click="prevMonth()">
                    <v-icon>
                      keyboard_arrow_left
                    </v-icon>
                  </v-btn>
                  <v-menu
                    class="d-inline-block"
                    ref="menu1"
                    :close-on-content-click="false"
                    v-model="menu1"
                    :nudge-right="40"
                    :return-value.sync="currentDateD"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      class="small-input"
                      slot="activator"
                      v-model="currentDateString"
                      label=""
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="currentDateD" type="month" @change="changeCurrentDateD" @input="$refs.menu1.save(currentDateD)" no-title locale="pl"></v-date-picker>
                  </v-menu>
                  <v-btn flat class='upper' small icon v-tooltip="'następny'" @click="nextMonth()">
                    <v-icon>
                      keyboard_arrow_right
                    </v-icon>
                  </v-btn>
                </span>
                <span class="d-inline-block" v-if="$mq === 'sm'">
                  <v-btn flat class="upper" small icon v-tooltip="'poprzedni'" @click="prevWeek()">
                    <v-icon>
                      keyboard_arrow_left
                    </v-icon>
                  </v-btn>
                  <v-menu
                    class="d-inline-block"
                    ref="menu2"
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="40"
                    :return-value.sync="currentDateWeekD"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="currentDateWeekString"
                      label=""
                      readonly
                    ></v-text-field>
                    <v-date-picker first-day-of-week=1 v-model="currentDateWeekD" @change="changeCurrentDateWeekD" @input="$refs.menu2.save(currentDateWeekD)" no-title locale="pl"></v-date-picker>
                  </v-menu>
                  <v-btn flat class='upper' small icon v-tooltip="'następny'" @click="nextWeek()">
                    <v-icon>
                      keyboard_arrow_right
                    </v-icon>
                  </v-btn>
                </span>
              </v-flex>
              <v-flex md4 v-if="isActiveRunnerTrainer">
                <div class="header-text">
                <span>Nowy trening</span>
                <rp-icon
                  type="arrow_forward"
                  tooltip="skopiuj treningi z poprzedniego miesiąca"
                  @click="copyWorkoutsMonth(currentDate)"
                />
                <rp-icon
                  type="people"
                  tooltip="skopiuj treningi innego zawodnika"
                  @click="copyWorkoutsMonthRunner(currentDate)"
                />
                </div>
              </v-flex>
              <notifications-push-init v-if="runner.user === authUser.user" mini></notifications-push-init>
            </v-layout>
        </v-flex>
      </v-layout>
      <v-divider />
      <v-layout>
        <v-flex>
          <table id="calendar">
            <tr class="weekdays">
              <th scope="col" class="nohover"></th>
              <th scope="col">Poniedziałek</th>
              <th scope="col">Wtorek</th>
              <th scope="col">Środa</th>
              <th scope="col">Czwartek</th>
              <th scope="col">Piątek</th>
              <th scope="col">Sobota</th>
              <th scope="col">Niedziela</th>
              <th scope="col" class="nohover">
                <v-icon v-tooltip="'Suma kilometrów'">mdi-sigma</v-icon>
              </th>
            </tr>

            <tr class="days" v-for="week of calendarView.weeks">
              <td class="nohover">
                <span class="icon-group">
                <span v-if="isActiveRunnerTrainer" class="week-icon">
                  <rp-icon
                    type="done"
                    small
                    tooltip="oznacz treningi jako wykonane"
                    @click="doneWorkoutsWeek(week)"
                  />
                </span>
                <span v-if="isActiveRunnerTrainer" class="week-icon">
                  <rp-icon
                    type="clear"
                    small
                    tooltip="oznacz treningi jako niewykonane"
                    @click="undoneWorkoutsWeek(week)"
                  />
                </span>
                </span>
                <span class="icon-group">
                <span v-if="isActiveRunnerTrainer" class="week-icon">
                  <rp-icon
                    type="delete"
                    small
                    tooltip="usuń treningi z tego tygodnia"
                    @click="removeWorkoutsWeek(week)"
                  />
                </span>
                <span v-if="isActiveRunnerTrainer" class="week-icon">
                  <rp-icon
                    type="arrow_downward"
                    small
                    tooltip="skopiuj treningi na następny tydzień"
                    @click="copyWorkoutsWeek(week)"
                  />
                </span>
                </span>
              </td>
              <td v-for="(day, index) of week.days" class="day" :id="'day-' + day.date.format('YYMMDD')" @click.stop="dayClick(day, $event)" :class="{ 'other-month': day.otherMonth }">
                <template v-if="!day.events.length && ($mq !== 'sm' || !eventForm || !eventForm.datetime.isSame(day.date, 'day'))">
                  <div class="day-date">{{day.date.date()}} <template v-if="$mq == 'sm'">({{ day.date.format('dddd')}})</template></div>
                </template>
                <template v-if="$mq !== 'sm'" v-for="ev of day.events">
                  <workout-small
                    v-if="ev.dayVisible && ev.isWorkout"
                    :micro="day.events.length > 1"
                    :workout="ev"
                    :key="ev.id"
                    @click.native.stop="eventClick(ev, $event)"
                    @edit-workout="editEvent(ev)"
                    @done-workout="doneWorkoutHandler(ev)"
                    @undone-workout="undoneWorkoutHandler(ev)"
                    @remove-workout="removeWorkout(ev)"
                    ></workout-small>
                  <race-small
                    v-if="ev.dayVisible && ev.isRace"
                    :race="ev"
                    :key="ev.id"
                    @click.native.stop="eventClick(ev, $event)"
                    @edit-race="editEvent(ev)"
                    @remove-race="removeRace(ev)"></race-small>
                  <activity-small
                    v-if="ev.dayVisible && ev.isActivity"
                    :activity="ev"
                    :key="ev.id"
                    @click.native.stop="eventClick(ev, $event)"
                    @edit-activity="editEvent(ev)"
                    @remove-activity="removeActivity(ev)"></activity-small>
                </template>
                <template v-if="$mq === 'sm'" v-for="ev of day.events" >
                  <workout-big
                    v-if="ev.dayVisible && ev.isWorkout && eventForm !== ev"
                    :key="ev.id"
                    inplace
                    :workout="ev"
                    @edit-workout="editEvent(ev)"
                    @done-workout="doneWorkoutHandler(ev)"
                    @undone-workout="undoneWorkoutHandler(ev)"
                    @remove-workout="removeWorkout(ev)"
                    @ended-workout="endedWorkout"></workout-big>
                  <race-big
                    v-if="ev.dayVisible && ev.isRace && eventForm !== ev"
                    :key="ev.id"
                    inplace
                    :race="ev"
                    @edit-race="editEvent(ev)"
                    @remove-race="removeRace(ev)"
                    @ended-race="endedRace"
                    ></race-big>
                  <activity-big
                    v-if="ev.dayVisible && ev.isActivity && eventForm !== ev"
                    :key="ev.id"
                    inplace
                    :activity="ev"
                    @edit-activity="editEvent(ev)"
                    @remove-activity="removeActivity(ev)"
                    ></activity-big>
                </template>
                <template v-if="$mq === 'sm'">
                  <workout-form
                    v-if="eventForm && eventForm.isWorkout && eventForm.datetime.isSame(day.date, 'day')"
                    inplace
                    :ev="eventForm"
                    @close="closeForm()"
                    @created-workout="createdEvent"
                    @updated-workout="updatedEvent"></workout-form>
                  <race-form
                    v-if="eventForm && eventForm.isRace && eventForm.datetime.isSame(day.date, 'day')"
                    inplace
                    :ev="eventForm"
                    @close="closeForm()"
                    @created-race="createdEvent"
                    @updated-race="updatedEvent"></race-form>
                  <activity-form
                    v-if="eventForm && eventForm.isActivity && eventForm.datetime.isSame(day.date, 'day')"
                    inplace
                    :ev="eventForm"
                    @close="closeForm()"
                    @created-activity="createdEvent"
                    @updated-activity="updatedEvent"></activity-form>
                </template>
                <div class="day-actions">
                    <span>
                      <rp-icon tooltip="Dzień niedostępny" class="very-small" v-if="!day.isOpen && isActiveRunner" @click="openPlanDay(day, $event)" type="block" />

                      <rp-icon tooltip="Dzień dostępny" class="very-small" v-if="day.isOpen && isActiveRunner" @click="closePlanDay(day, $event)" type="check_circle_outline" />
                      <v-icon v-tooltip="'Dzień niedostępny'" class="very-small" v-if="!day.isOpen && !isActiveRunner">block</v-icon>
                    </span>

                    <span>
                      <v-btn small class="very-small" color="primary" v-if="day.isOpen && isActiveRunnerTrainer" @click.stop="newWorkout(day, $event)">
                        trening
                        <v-icon right small >add_circle</v-icon>
                      </v-btn>
                      <v-btn small class="very-small" dark color="tertiary" v-if="day.isOpen && (isActiveRunnerTrainer || isActiveRunner)" @click.stop="newRace(day, $event)">
                        zawody
                        <v-icon right small>add_circle</v-icon>
                      </v-btn>
                      <v-btn small class="very-small" dark color="accent" v-if="day.isOpen && isActiveRunner" @click.stop="newActivity(day, $event)">
                        aktywność
                        <v-icon right small>add_circle</v-icon>
                      </v-btn>
                    </span>
                </div>
              </td>
              <td class="nohover week-summary">
                <div>
                  <span v-tooltip="'Zaplanowano'"><div class="week-summary-distance">{{ week.totalPlanned }}</div>km</span>
                </div>
                <div>
                  <span v-tooltip="'Wykonano'"><div class="week-summary-distance">{{ week.totalDone }}</div>km</span>
                </div>
              </td>
            </tr>
          </table>
            <runner-heart-rate></runner-heart-rate>
          <template v-if="$mq !== 'sm'">
          <workout-big
            v-if="currentEvent && currentEvent.isWorkout"
            @click.native.stop="insideClick($event)"
            :key="currentEvent.id"
            :workout="currentEvent"
            @close="closeCurrent()"
            @edit-workout="editEvent(currentEvent)"
            @done-workout="doneWorkoutHandler(currentEvent)"
            @undone-workout="undoneWorkoutHandler(currentEvent)"
            @remove-workout="removeWorkout(currentEvent)"
            @ended-workout="endedWorkout"></workout-big>
          <race-big
            v-if="currentEvent && currentEvent.isRace"
            @click.native.stop="insideClick($event)"
            :key="currentEvent.id"
            :race="currentEvent"
            @close="closeCurrent()"
            @edit-race="editEvent(currentEvent)"
            @remove-race="removeRace(currentEvent)"
            @ended-race="endedRace"></race-big>
          <activity-big
            v-if="currentEvent && currentEvent.isActivity"
            @click.native.stop="insideClick($event)"
            :key="currentEvent.id"
            :activity="currentEvent"
            @close="closeCurrent()"
            @edit-activity="editEvent(currentEvent)"
            @remove-activity="removeActivity(currentEvent)"></activity-big>
          <workout-form
            v-if="eventForm && eventForm.isWorkout"
            :ev="eventForm"
            @close="closeForm()"
            @created-workout="createdEvent"
            @updated-workout="updatedEvent"></workout-form>
          <race-form
            v-if="eventForm && eventForm.isRace"
            :ev="eventForm"
            @close="closeForm()"
            @created-race="createdEvent"
            @updated-race="updatedEvent"></race-form>
          <activity-form
            v-if="eventForm && eventForm.isActivity"
            :ev="eventForm"
            @close="closeForm()"
            @created-activity="createdEvent"
            @updated-activity="updatedEvent"></activity-form>
          </template>
        </v-flex>
      </v-layout>
      </v-card>
    </v-container>

    <v-container grid-list-xl>
      <v-layout align-start justify-space-around row wrap fill-height>
        <v-flex sm12 lg6>
          <v-card>
            <plan-races></plan-races>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout align-start justify-space-around row wrap fill-height>
        <v-flex xs12 lg6>
          <v-card class="pa-3">
            <v-toolbar flat dense dark color="primary">
              <v-toolbar-title>
                Podsumowanie miesiąca
              </v-toolbar-title>
            </v-toolbar>
            <v-list>
              <v-list-tile @click="">
                <v-list-tile-content>
                  Suma km z planu: {{ calendarView.totalMonthPlanned }}
                </v-list-tile-content>
              </v-list-tile>
              <v-divider />
              <v-list-tile @click="">
                <v-list-tile-content>
                  Suma km wykonana: {{ calendarView.totalMonthDone }}
                </v-list-tile-content>
              </v-list-tile>
              <v-divider />
              <v-list-tile @click="">
                <v-list-tile-content>
                  Zaplanowanych treningów/zawodów:  {{ calendarView.totalMonthPlannedCount }}
                </v-list-tile-content>
              </v-list-tile>
              <v-divider />
              <v-list-tile @click="">
                <v-list-tile-content>
                  Wykonanych treningów/zawodów: {{ calendarView.totalMonthDoneCount }}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs12 lg6 v-if="records.length > 0">
          <v-card class="pa-3">
            <v-toolbar flat dense dark color="primary">
              <v-toolbar-title>
                Nowe rekordy
              </v-toolbar-title>
            </v-toolbar>
            <table class="v-table theme--light" v-if="records">
              <thead>
                <tr>
                  <th>Dystans</th>
                  <th>Czas</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="record in records">
                  <td class="text-xs-center">{{ record.distance_string_name }}</td>
                  <td class="text-xs-center">{{ record.time }}</td>
                  <td class="text-xs-center">{{ record.race_date | formatDate('LL') }}</td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout align-start justify-space-around row wrap fill-height>
        <v-flex sm12 lg6>
          <v-card>
            <plan-comments :month="currentDate"></plan-comments>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import iziToast from 'izitoast'
import moment from 'moment'

import {
  fetchPlan, deleteWorkout, deleteRace, deleteActivity,
  copyWorkoutsWeek, copyWorkoutsMonth, removeWorkoutsWeek,
  fetchRecords, openDay, closeDay, doneWorkout, undoneWorkout,
  doneWorkoutsWeek, undoneWorkoutsWeek} from '@/plan/api'
import {getCalendar} from '@/utils/calendar'

import WorkoutBig from './WorkoutBig'
import WorkoutSmall from './WorkoutSmall'
import WorkoutForm from './WorkoutForm'
import RaceBig from './RaceBig'
import RaceSmall from './RaceSmall'
import RaceForm from './RaceForm'
import ActivityBig from './ActivityBig'
import ActivitySmall from './ActivitySmall'
import ActivityForm from './ActivityForm'
import PlanComments from './PlanComments'
import PlanRaces from './PlanRaces'
import NotificationsPushInit from '@/notifications/NotificationsPushInit'
import RunnerHeartRate from '@/runners/RunnerHeartRate'
import Datepicker from 'vuejs-datepicker'
import {pl} from 'vuejs-datepicker/dist/locale'
import CopyWorkoutDialog from './CopyWorkoutDialog'
import VueScrollTo from 'vue-scrollto'

export default {
  components: {
    CopyWorkoutDialog,
    Datepicker,
    WorkoutBig,
    WorkoutSmall,
    WorkoutForm,
    RaceBig,
    RaceSmall,
    RaceForm,
    ActivityBig,
    ActivitySmall,
    ActivityForm,
    PlanComments,
    PlanRaces,
    NotificationsPushInit,
    RunnerHeartRate
  },
  props: {
    runnerData: {
      type: Object
    }
  },
  data () {
    return {
      menu1: false,
      menu2: false,
      currentDate: moment().startOf('month'),
      currentDateD: moment().startOf('month').format('YYYY-MM'),
      currentDateWeek: moment().startOf('week'),
      currentDateWeekD: moment().startOf('week').format('YYYY-MM-DD'),
      currentEvent: null,
      eventForm: null,
      records: [],
      calendar: null,
      events: [],
      dayStatus: {},
      language: pl
    }
  },
  computed: {
    ...mapGetters(['allPackagesOptions', 'authUser', 'isAdmin', 'isRunner', 'trainerRunnersOptions', 'isActiveRunnerTrainer', 'isActiveRunner']),
    ...mapState(['runnersTrainer', 'runner']),
    currentDateWeekString () {
      return this.currentDateWeek.format('DD-MM-YYYY') + ' - ' + moment(this.currentDateWeek).endOf('week').format('DD-MM-YYYY')
    },
    currentDateString () {
      return this.currentDate.format('MMMM YYYY')
    },
    viewType () {
      return this.$mq === 'sm' ? 'week' : 'month'
    },
    calendarView () {
      let weeks = []

      if (this.calendar === null) {
        return {
          totalPlanned: 0,
          totalDone: 0,
          totalPlannedCount: 0,
          totalDoneCount: 0,
          totalMonthPlanned: 0,
          totalMonthDone: 0,
          totalMonthPlannedCount: 0,
          totalMonthDoneCount: 0,
          weeks: []
        }
      }
      for (let week of this.calendar.weeks) {
        if (this.viewType === 'month') {
          weeks.push(week)
        } else if (this.viewType === 'week') {
          if (week.date.isSame(this.currentDateWeek)) {
            weeks.push(week)
          }
        }
      }
      return {
        totalPlanned: this.calendar.totalPlanned,
        totalDone: this.calendar.totalDone,
        totalPlannedCount: this.calendar.totalPlannedCount,
        totalDoneCount: this.calendar.totalDoneCount,
        totalMonthPlanned: this.calendar.totalMonthPlanned,
        totalMonthDone: this.calendar.totalMonthDone,
        totalMonthPlannedCount: this.calendar.totalMonthPlannedCount,
        totalMonthDoneCount: this.calendar.totalMonthDoneCount,
        weeks: weeks
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  created () {
    this.fetchPlan().then(() => {
      if (this.$mq === 'sm') {
        this.$nextTick().then(function () {
          let el = document.getElementById('day-' + moment().format('YYMMDD'))
          if (el) {
            var options = {
              easing: 'ease-in',
              offset: -60,
              force: true,
              x: false,
              y: true
            }
            VueScrollTo.scrollTo(el, options)
          }
        })
      }
    })
  },
  watch: {
    '$route': 'fetchPlan'
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    nextMonth () {
      // trzeba zrobic moment aby vue zalapal zmiany i przeliczyl currentDateString
      this.currentDate = moment(this.currentDate.add(1, 'month'))
      this.currentDateD = this.currentDate.format('YYYY-MM')
      this.changeCurrentDateWeek()
      this.fetchPlan()
    },
    prevMonth () {
      this.currentDate = moment(this.currentDate.subtract(1, 'month'))
      this.currentDateD = this.currentDate.format('YYYY-MM')
      this.changeCurrentDateWeek()
      this.fetchPlan()
    },
    changeCurrentDateD () {
      this.currentDate = moment(this.currentDateD)
      this.changeCurrentDateWeek()

      this.fetchPlan()
    },
    nextWeek () {
      this.currentDateWeek = moment(this.currentDateWeek.add(1, 'week'))
      this.currentDateWeekD = this.currentDateWeek.format('YYYY-MM-DD')
      this.changeCurrentDate()
      this.fetchPlan()
    },
    prevWeek () {
      this.currentDateWeek = moment(this.currentDateWeek.subtract(1, 'week'))
      this.currentDateWeekD = this.currentDateWeek.format('YYYY-MM-DD')
      this.changeCurrentDate()
      this.fetchPlan()
    },
    changeCurrentDateWeekD () {
      this.currentDateWeek = moment(this.currentDateWeekD).startOf('week')
      this.currentDateWeekD = this.currentDateWeek.format('YYYY-MM-DD')
      this.changeCurrentDate()

      this.fetchPlan()
    },
    changeCurrentDateWeek () {
      this.currentDateWeek = moment(this.currentDate).startOf('week')
      this.currentDateWeekD = this.currentDateWeek.format('YYYY-MM-DD')
    },
    changeCurrentDate () {
      this.currentDate = moment(this.currentDateWeek).startOf('month')
      this.currentDateD = this.currentDate.format('YYYY-MM')
    },
    prepareEvent (e) {
      this.$set(e, 'dayVisible', true)
      this.$set(e, 'position', null)
      this.$set(e, 'el', null)
      this.$set(e, 'isRace', e.type === 'race')
      this.$set(e, 'isWorkout', e.type === 'workout')
      this.$set(e, 'isActivity', e.type === 'activity')

      if (e.type === 'workout') {
        e.datetime = moment(e.workout_date)
        e.planned = parseFloat(e.total_distance_planned || 0)
        e.done = parseFloat(e.total_distance_done || 0)
      }
      if (e.type === 'race') {
        e.datetime = moment(e.race_date)
        e.planned = Math.ceil(parseFloat(e.distance / 1000 || 0))
        e.done = Math.ceil(parseFloat(e.time ? e.distance / 1000 || 0 : 0))
      }
      if (e.type === 'activity') {
        e.datetime = moment(e.activity_date)
        e.planned = 0
        e.done = parseFloat(e.total_distance_done || 0)
      }
    },
    fetchPlan () {
      this.fetchRecordsList()
      return fetchPlan(this.runner, {month: this.currentDate.format('YYYY-MM')}).then((data) => {
        this.events = data.events
        this.dayStatus = data.day_status
        this.events.forEach(e => {
          this.prepareEvent(e)
        })
        this.calendar = getCalendar(this.currentDate, this.events, this.dayStatus)
      })
    },
    fetchRecordsList () {
      let promise = fetchRecords(this.runner, {month: this.currentDate.format('YYYY-MM')})
      return promise.then((data) => {
        this.records = data.results
      })
    },
    computePos (target) {
      let eventRect = target.closest('.day').getBoundingClientRect()
      let cEventRect = target.closest('.container').getBoundingClientRect()
      let topOffset = 0
      if (eventRect.top < 70) {
        topOffset = 70 - eventRect.top
      }
      let width = 350
      let height = 400
      let maxLeftOffset = Math.min(eventRect.left - 10, width - eventRect.width)
      let minLeftOffset = 0
      let minTop = Math.max(0, eventRect.top - cEventRect.top)
      let minLeft = Math.max(0, eventRect.left - cEventRect.left)
      let defaultLeftOffset = (width - eventRect.width) / 2
      defaultLeftOffset = Math.min(maxLeftOffset, defaultLeftOffset)
      defaultLeftOffset = Math.max(minLeftOffset, defaultLeftOffset)
      let computedLeft = minLeft + window.pageXOffset - defaultLeftOffset
      let computedTop = minTop - 15 + topOffset
      let additionalLeftOffset = Math.min(0, cEventRect.right - (computedLeft + width + cEventRect.left))
      let additionalTopOffset = Math.min(0, window.innerHeight - (eventRect.top + height))
      return {
        left: Math.max(0, computedLeft + additionalLeftOffset),
        top: Math.max(70, computedTop + additionalTopOffset)
      }
    },
    handleResize (event) {
      if (this.currentEvent && this.currentEvent.el) {
        let pos = this.computePos(this.currentEvent.el)
        this.currentEvent.position = pos
      } else if (this.eventForm && this.eventForm.el) {
        let pos = this.computePos(this.eventForm.el)
        this.eventForm.position = pos
      }
    },
    eventClick: function (ev, jsEvent) {
      this.close()
      let pos = this.computePos(jsEvent.currentTarget)
      ev.position = pos
      ev.el = jsEvent.currentTarget
      this.currentEvent = ev
    },
    dayClick: function (day, jsEvent) {
      if (jsEvent.target.closest('.bigEvent')) {
        return false
      }
      this.close()
    },
    insideClick: function (jsEvent) {
      if (jsEvent.target.closest('form')) {
        return false
      }
      this.close()
    },
    close: function () {
      this.closeForm()
      this.closeCurrent()
    },
    closeForm: function () {
      if (this.eventForm) {
        this.eventForm = null
      }
    },
    closeCurrent: function () {
      if (this.currentEvent) {
        this.currentEvent = null
      }
    },
    newEvent: function (day, jsEvent) {
      let pos = this.computePos(jsEvent.currentTarget)
      this.close()
      this.eventForm = {}
      this.eventForm.el = jsEvent.currentTarget.closest('.day')
      this.eventForm.position = pos
    },
    newWorkout: function (day, jsEvent) {
      this.newEvent(day, jsEvent)
      this.eventForm.workout_date = day.date.format('YYYY-MM-DD')
      this.eventForm.datetime = day.date
      this.eventForm.workout_type = 'OWB1'
      this.eventForm.isWorkout = true
    },
    newRace: function (day, jsEvent) {
      this.newEvent(day, jsEvent)
      this.eventForm.race_date = day.date.format('YYYY-MM-DD')
      this.eventForm.datetime = day.date
      this.eventForm.isRace = true
    },
    newActivity: function (day, jsEvent) {
      this.newEvent(day, jsEvent)
      this.eventForm.activity_date = day.date.format('YYYY-MM-DD')
      this.eventForm.datetime = day.date
      this.eventForm.isActivity = true
    },
    editEvent: function (ev) {
      let target = document.getElementById('day-' + ev.datetime.format('YYMMDD'))
      let pos = this.computePos(target)
      this.close()
      this.eventForm = ev
      this.eventForm.position = pos
      this.eventForm.el = target
    },
    createdEvent: function (data) {
      this.prepareEvent(data)
      this.close()
      this.fetchPlan()
      this.events.push(data)
      this.calendar = getCalendar(this.currentDate, this.events, this.dayStatus)
    },
    updatedEvent: function (data, ev) {
      this.prepareEvent(data)
      let index = this.events.indexOf(ev)
      this.events[index] = data
      this.close()
      this.calendar = getCalendar(this.currentDate, this.events, this.dayStatus)
    },
    endedWorkout: function (data, ev) {
      this.$set(ev, 'total_distance_done', data.total_distance_done)
      this.$set(ev, 'runner_pulse', data.runner_pulse)
      this.$set(ev, 'runner_time', data.runner_time)
      this.$set(ev, 'runner_additional_info', data.runner_additional_info)
      this.prepareEvent(data)
      let index = this.events.indexOf(ev)
      this.events[index] = data
      this.calendar = getCalendar(this.currentDate, this.events, this.dayStatus)
      this.close()
    },
    endedRace: function (data, ev) {
      this.$set(ev, 'place', data.place)
      this.$set(ev, 'time', data.time)
      this.$set(ev, 'post_remarks', data.post_remarks)
      this.prepareEvent(data)
      let index = this.events.indexOf(ev)
      this.events[index] = data
      this.calendar = getCalendar(this.currentDate, this.events, this.dayStatus)
      this.close()
    },
    doneWorkoutHandler: function (ev) {
      let data = {
        id: ev.id,
        total_distance_planned: ev.total_distance_planned,
        total_distance_done: ev.total_distance_planned
      }
      doneWorkout(this.runner, data).then(() => {
        this.$set(ev, 'total_distance_done', ev.total_distance_planned)
        this.$set(ev, 'workout_done', true)
        this.$set(ev, 'done', parseFloat(ev.total_distance_done) || 0)
        this.calendar = getCalendar(this.currentDate, this.events, this.dayStatus)
        this.close()
      })
    },
    undoneWorkoutHandler: function (ev) {
      undoneWorkout(this.runner, ev).then((data) => {
        this.$set(ev, 'total_distance_done', null)
        this.$set(ev, 'runner_pulse', null)
        this.$set(ev, 'runner_time', null)
        this.$set(ev, 'runner_additional_info', data.runner_additional_info)
        this.$set(ev, 'workout_done', false)
        this.$set(ev, 'done', 0)
        this.calendar = getCalendar(this.currentDate, this.events, this.dayStatus)
        this.close()
      })
    },
    removeWorkout: function (ev) {
      this.$root.$confirm('Usuń trening', 'Czy na pewno usunąć ten trening?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (!willDelete) { return }
        let promise = deleteWorkout(this.runner, ev)
        return promise.then(() => {
          let index = this.events.indexOf(ev)
          this.events.splice(index, 1)
          this.calendar = getCalendar(this.currentDate, this.events, this.dayStatus)
          iziToast.show({
            message: 'Trening został usunięty',
            color: 'green'
          })
          this.close()
        }).catch(() => {
          iziToast.show({
            message: 'Nie udało się usunąć treningu.',
            color: 'red'
          })
        })
      })
    },
    removeRace: function (ev) {
      this.$root.$confirm('Usuń zawody', 'Czy na pewno usunąć te zawody?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (!willDelete) { return }
        let promise = deleteRace(this.runner, ev)
        return promise.then(() => {
          this.close()
          this.fetchPlan()
          iziToast.show({
            message: 'Zawody zostały usunięte',
            color: 'green'
          })
          this.close()
        }).catch(() => {
          iziToast.show({
            message: 'Nie udało się usunąć zawodów.',
            color: 'red'
          })
        })
      })
    },
    removeActivity: function (ev) {
      this.$root.$confirm('Usuń aktywność', 'Czy na pewno usunąć tą aktywność?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (!willDelete) { return }
        let promise = deleteActivity(this.runner, ev)
        return promise.then(() => {
          this.close()
          this.fetchPlan()
          iziToast.show({
            message: 'Aktywność została usunięta',
            color: 'green'
          })
          this.close()
        }).catch(() => {
          iziToast.show({
            message: 'Nie udało się usunąć aktywności.',
            color: 'red'
          })
        })
      })
    },
    removeWorkoutsWeek: function (week) {
      this.$root.$confirm('Usuń treningi', 'Czy na pewno usunąć ten treningi z całego tygodnia?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (!willDelete) { return }
        removeWorkoutsWeek(
          this.runner,
          {
            from_start: week.date.format('YYYY-MM-DD')
          }).then((data) => {
          this.fetchPlan()
        })
      })
    },
    doneWorkoutsWeek: function (week) {
      this.$root.$confirm('Treningi wykonane', 'Czy na pewno oznaczyć treningi z całego tygodnia jako wykonane?', {confirmText: 'Tak', color: 'error'}).then((ok) => {
        if (!ok) { return }
        doneWorkoutsWeek(
          this.runner,
          {
            from_start: week.date.format('YYYY-MM-DD')
          }).then((data) => {
          this.fetchPlan()
        })
      })
    },
    undoneWorkoutsWeek: function (week) {
      this.$root.$confirm('Treningi niewykonane', 'Czy na pewno oznaczyć treningi z całego tygodnia jako niewykonane?', {confirmText: 'Tak', color: 'error'}).then((ok) => {
        if (!ok) { return }
        undoneWorkoutsWeek(
          this.runner,
          {
            from_start: week.date.format('YYYY-MM-DD')
          }).then((data) => {
          this.fetchPlan()
        })
      })
    },
    copyWorkoutsWeek: function (week) {
      copyWorkoutsWeek(
        this.runner,
        {
          from_start: week.date.format('YYYY-MM-DD'),
          to_start: week.date.add(7, 'days').format('YYYY-MM-DD')
        }).then((data) => {
        this.fetchPlan()
      })
    },
    copyWorkoutsMonth: function (date) {
      copyWorkoutsMonth(
        this.runner,
        {
          from_start: moment(date).subtract(1, 'months').format('YYYY-MM-DD'),
          to_start: date.format('YYYY-MM-DD')
        }).then((data) => {
        this.fetchPlan()
      })
    },
    copyWorkoutsMonthRunner: function (date) {
      this.$refs.copyWorkout.open({runners: this.trainerRunnersOptions}).then((data) => {
        copyWorkoutsMonth(
          this.runner,
          {
            from_start: date.format('YYYY-MM-DD'),
            to_start: date.format('YYYY-MM-DD'),
            runner: data.value
          }).then((data) => {
          this.fetchPlan()
        })
      })
    },
    openPlanDay: function (day, jsEvent) {
      openDay(this.runner, day.date).then(() => {
        day.isOpen = true
      })
    },
    closePlanDay: function (day, jsEvent) {
      closeDay(this.runner, day.date).then(() => {
        day.isOpen = false
      })
    }
  }
}
</script>
<style>
  .header-text {
    padding-top: 8px;
    padding-left: 16px;
    margin-top: 4px;
    font-size: 16px;
  }
  .v-btn.upper {
    margin-bottom: 12px;
  }
  .small-input {
    width: 150px;
  }
  .plan .container {
    padding: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/plan/Plan.vue